import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { FileDigitale } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { ACSupporto } from "./autocompletes"
import { FormikSelectVocabolario } from "./formsHelpers"

export default function FileDigitaleForm({ item, save, ref, language }: FormInDialogProps<FileDigitale>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        supporto: null,
        titolo: "",
        note_it: "",
        note_en: "",
        estensione: "",
      }
    )
  }, [item])

  const schema = useMemo(() => yup.object().shape({}), [t])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as FileDigitale).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={6}>
                <Field
                  name="filename"
                  label={t("fileDigitale.filename")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid size={6}>
                <ACSupporto
                  label={t("general.supporto")}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.supporto as number}
                  onChange={(value) => {
                    setFieldValue("supporto", value)
                  }}
                />
              </Grid>

              <Grid size={12}>
                <Field
                  name="posizione_file"
                  label={t("fileDigitale.posizione_file")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={12}>
                <Field
                  name="posizione_lto"
                  label={t("fileDigitale.posizione_lto")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={6}>
                <Field
                  name="estensione"
                  label={t("fileDigitale.estensione")}
                  component={FormikSelectVocabolario}
                  vocabolario="estensione_files"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    name="titolo_it"
                    label={t("fileDigitale.titolo")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                  />
                ) : (
                  <Field
                    name="titolo_en"
                    label={t("fileDigitale.titolo")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                  />
                )}
              </Grid>
              <Grid size={6}>
                <Field
                  name="tipo_file"
                  label={t("fileDigitale.tipo_file")}
                  component={FormikSelectVocabolario}
                  vocabolario="tipo_file"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    name="note_tecniche_it"
                    label={t("fileDigitale.note_tecniche")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    name="note_tecniche_en"
                    label={t("fileDigitale.note_tecniche")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    name="note_it"
                    label={t("fileDigitale.note")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    name="note_en"
                    label={t("fileDigitale.note")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
